"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertType = void 0;
exports.instanceOfAlertType = instanceOfAlertType;
exports.AlertTypeFromJSON = AlertTypeFromJSON;
exports.AlertTypeFromJSONTyped = AlertTypeFromJSONTyped;
exports.AlertTypeToJSON = AlertTypeToJSON;
exports.AlertTypeToJSONTyped = AlertTypeToJSONTyped;
/**
 *
 * @export
 */
exports.AlertType = {
    ProfileComplete: 'PROFILE_COMPLETE'
};
function instanceOfAlertType(value) {
    for (const key in exports.AlertType) {
        if (Object.prototype.hasOwnProperty.call(exports.AlertType, key)) {
            if (exports.AlertType[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function AlertTypeFromJSON(json) {
    return AlertTypeFromJSONTyped(json, false);
}
function AlertTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function AlertTypeToJSON(value) {
    return value;
}
function AlertTypeToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=AlertType.js.map